import Vue from 'vue';
import { Model } from 'vue-mc';
import axiosConfig from './config';

export default class extends Model {
	/**
	 * Creates a new instance
	 *
	 * @param {Object} attributes Model attributes
	 * @param {Collection} collection Collection that this model belongs to
	 * @param {Object} options Options to set on the model
	 */
	constructor(attributes = {}, collection = null, options = {}) {
		super(attributes, collection, options);
		this._relations = {};
		this.skipValidation = false;
		this.init();
	}

	init() {}

	/**
	 * Return true if model is changing (loading, saving, or deleting)
	 * @returns {boolean}
	 */
	get changing() {
		return (this.loading || this.saving || this.deleting);
	}

	relation(relationName, findCallback) {
		if (typeof this._relations[relationName] === 'undefined') {
			let storeData = this.$store.get(relationName);
			if (storeData.length === 0) {
				return null;
			}

			this._relations[relationName] = storeData.find(findCallback);
			if (this._relations[relationName] === undefined) {
				this._relations[relationName] = null;
			}
		}

		return this._relations[relationName];
	}

	getRequest(config) {
		axiosConfig(config);
		return super.getRequest(config);
	}

	hasErrors() {
		return Object.keys(this.errors).length > 0;
	}

	/**
	 * Called when a fetch request failed
	 *
	 * @param {Error} error
	 */
	onFetchFailure(error) {
		if (error.message === 'Network Error')
			window.location.href = "https://reportmule.com/maintenance.html";

		Vue.set(this, 'fatal', true);
		Vue.set(this, 'loading', false);

		this.emit('fetch', { error });
	}
}
